import {Observable} from "rxjs/internal/Observable";
import {Global} from "./global";
import Events from "../service/events";
import EVENTS from "../constants/events";

let debounce = require('lodash.debounce');

export interface Viewport {
    width: number,
    height: number,
}

export class ViewportService {

    protected started: boolean = false;
    protected state: string;
    protected viewport: Viewport;
    public events: Events;

    protected breakpoints: any = {
        mobile: 0,
        xlargemobile: 640,
        smalldesktop: 768,
        desktop: 1024,
        middesktop: 1150
    }

    constructor(events: Events) {
        this.events = events;
    }

    start = () => {
        if (!this.started) {
            this.viewport = Global.getViewport();
            this.state = this.breakpointBySize(Global.getViewport().width);
            this.observeViewport().subscribe(this.handleUpdate);
            this.started = true;
        }
        this.events.emit(EVENTS.VIEWPORT_RESIZE, this.viewport);
        this.events.emit(EVENTS.VIEWPORT_START, this.state);
    }

    handleUpdate = (size: Viewport) => {
        this.viewport = size;
        this.events.emit(EVENTS.VIEWPORT_RESIZE, size)
        let breakpoint = this.breakpointBySize(size.width);
        if (breakpoint !== this.state) {
            this.state = breakpoint;
            this.events.emit(EVENTS.VIEWPORT_CHANGE, breakpoint)
        }
    };

    protected observeViewport = () => new Observable(observer => <any>$(window).on('resize', debounce(() => observer.next(Global.getViewport()))));
    protected breakpointBySize = (width: number) => Object.keys(this.breakpoints).filter((key) => width >= this.breakpoints[key]).pop();
}